// 🔧 sponsor_step.js
// ✅ Purpose: Pipeline step for the Sponsors Add-on Engine
// ✅ Features:
// - Executes Sponsor Engine
// - Registers Sponsor Engine within the Demo Pipeline
// - Uses the standard Demo Pipeline `run` method
// - Provides id, name, and label for reporting compatibility
// - Fully block-commented for clarity and future devs

import { runSponsorEngine } from "../../engines/sponsors";

export const createSponsorStep = () => ({
  id: "sponsor_builder",

  name: "Sponsor Builder",

  label: "Sponsor Builder",

  run: async (demoContext) => {
    return await runSponsorEngine({
      demoContext,
    });
  },
});